import * as React from "react";
function SvgNewMinus(props) {
  return <svg width={27} height={3} viewBox="0 0 27 3" fill="#DC582E" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 1.5C0 0.671573 0.671573 0 1.5 0H25.5C26.3284 0 27 0.671573 27 1.5C27 2.32843 26.3284 3 25.5 3H1.5C0.671573 3 0 2.32843 0 1.5Z" fill="inherit" /></svg>;
}
export default SvgNewMinus;